import { Department } from 'src/api/model/department';
import { RequestBuilder } from 'src/api/common/request-builder';
// import { DepartmentModule } from '@/store/modules/department'
import { DepartmentSearchForm } from 'src/api/model/search/department-search-form';
import { Pagable } from 'src/constants/pagable';
import { RequestUtils } from 'src/utils/request-utils';
import { DepartmentForm } from 'src/api/model/form/department-form';
import { DepartmentData } from '../model/response/department-data';
import { Page } from '../common/page';

export class DepartmentApi {
  findAll(
    form: DepartmentSearchForm,
    pagable: Pagable,
  ): Promise<Department[]> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Department>()
      .url('/member/department')
      .config({ params: params })
      .findAll();
  }

  getAll(): Promise<Department[]> {
    return new RequestBuilder<Department>()
      .url('/work/department/getAll')
      .findAll();
  }

  findAllForAdmin(
    form: DepartmentSearchForm,
    pagable: Pagable,
  ): Promise<Department[]> {
    pagable.size = 10000;
    pagable.page = 0;
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Department>()
      .url('/member/department')
      .config({ params: params })
      .findAll();
  }

  findAllSubDepartments(
    form: DepartmentSearchForm,
    pagable: Pagable,
  ): Promise<Department[]> {
    const params = RequestUtils.initPageableParams(pagable);
    return new RequestBuilder<Department>()
      .url(
        `/member/department/findAllSubDepartments?deptId=${form.deptId}&includeDept=false`,
      )
      .config({ params: params })
      .findAll();
  }

  findAllSub(
    form: DepartmentSearchForm,
  ): Promise<Department[]> {
    return new RequestBuilder<Department>()
      .url(
        `/member/department/findAllSub?deptId=${form.deptId}&includeDept=false`,
      )
      .findAll();
  }

  findAllSubIds(id: string): Promise<string[]> {
    return new RequestBuilder<string>()
      .url(`/member/department/findAllSubId`)
      .config({ params: { deptId: id } })
      .findAll();
  }

  getDataPagging(
    form: DepartmentSearchForm,
    pagable: Pagable,
  ): Promise<Page<Department>> {
    const params = RequestUtils.merge(
      form,
      RequestUtils.initPageableParams(pagable),
    );
    return new RequestBuilder<Department>()
      .url('/member/department/getDataPagging')
      .config({ params: params })
      .findAllPagging();
  }

  findById(id: string): Promise<Department> {
    return new RequestBuilder<Department>()
      .url(`/member/department/${id}`)
      .findOne();
  }

  save(form: DepartmentForm) {
    return new RequestBuilder<Department>()
      .url('/member/department')
      .data(form)
      .post();
  }

  update(id: string, form: DepartmentForm) {
    return new RequestBuilder<Department>()
      .url(`/member/department/${id}`)
      .data(form)
      .put();
  }

  delete(id: string) {
    return new RequestBuilder<Department>()
      .url(`/member/department/${id}`)
      .delete();
  }

  getDepartments(): Promise<DepartmentData[]> {
    return new RequestBuilder<DepartmentData>()
      .url(`/member/department/getAll`)
      .findAll();
  }
}

export const departmentApi = new DepartmentApi();
